module.exports = __webpack_public_path__ + "static/media/160a.ada89693.svg";